<template>
    <div v-if="componentLoader" class="position-relative h-100">
        <app-overlay-loader/>
    </div>
    <div v-else>
        <app-overlay-loader v-if="preloader"/>
        <form class="mb-0" v-else ref="form" data-url="/container-settings"
              :class="{'loading-opacity': preloader}">
            <div class="form-group">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 d-flex">
                        <label class="text-left d-block mb-lg-2 mb-xl-0">{{ $t('container_use_cdn') }}</label>
                    </div>
                    <div class="col-lg-8 col-xl-8">
                        <app-input type="radio"
                                   :list="cdnList"
                                   @change="submit($event)"
                                   v-model="containerdetails.use_cdn"/>
                        <br />
                        <span v-html="$t('container_cdn_description')"></span>
                    </div>
                </div>
            </div>
        </form>
        <hr />
        <div class="row">
            <div class="col-lg-6 col-xl-7">
                <draggable tag="div"
                        v-model="domainNames"
                        v-bind="dragOptions"
                        @start="dragstart($event)"
                        @end="dragend($event)"
                        @change="change($event)">
                    <app-pre-loader v-if="!isActive"/>
                    <div class="row py-half-primary"
                            v-for="(domainName, index) in this.domainNames"
                            :key="'domain-name'+index">
                        <div class="col-4 col-lg-4">
                            <div class="d-flex align-items-center">
                                <div class="cursor-grab mr-3">
                                    <app-icon name="align-justify" class="text-muted"/>
                                </div>
                                <div>
                                    <div class="icon-box mr-2" key="clipboard">
                                        <app-icon name="clipboard"/>
                                    </div>
                                </div>
                                {{ $t(domainName.status) }}
                            </div>
                        </div>
                        <div class="col-7 col-lg-7 mt-2 mt-lg-0">
                            <div v-if="domainName.domain && !domainName.edit"
                                    :key="'with-link-'+index"
                                    class="h-100 d-flex align-items-center justify-content-between">
                                <p class="mb-0 mr-2">{{ domainName.domain }}</p>
                                <div v-if="domainName.is_default!=1" class="btn-group btn-group-action">
                                    <button type="button"
                                            class="btn"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            :title="$t('edit')"
                                            @click.prevent="editToggle(index)">
                                        <app-icon name="edit"/>
                                    </button>
                                    <button type="button"
                                            class="btn"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            :title="$t('remove_link')"
                                            @click.prevent="removeDomainName(index)">
                                        <app-icon name="trash"/>
                                    </button>
                                </div>
                            </div>
                            <div v-else
                                    class="h-100"
                                    :key="'without-link-'+index">
                                <div v-if="domainName.edit"
                                        :key="'without-link-edit-'+index"
                                        class="d-flex align-items-center h-100">
                                    <app-input :id="'domain-name-'+index"
                                                class="mr-2 flex-grow-1"
                                                type="text"
                                                placeholder="stats.yourdomain.com"
                                                v-model="domainName.domain"/>
                                    <button type="submit"
                                            class="btn btn-primary mr-2"
                                            @click.prevent="addDomainName(index)">
                                        {{ $t('save') }}
                                    </button>
                                    <a href="#" class="text-muted" @click.prevent="editToggle(index)">
                                        <app-icon name="x"/>
                                    </a>
                                </div>
                                <div v-else
                                        :key="'without-link-show-'+index"
                                        class="d-flex align-items-center justify-content-end h-100">
                                    <button type="submit" class="btn btn-primary"
                                            @click.prevent="editToggle(index)">
                                        {{ $t('add_new_domain') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </draggable>
                {{ $t('domain_ip_notes') }}
            </div>
            <div class="col-lg-6 col-xl-5">

            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import GlobalHelperMixin from "../../../Mixins/global/GlobalHelperMixin";
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import {UserMixin} from "../Auth/Mixins/UserMixin";
    import * as actions from "../../../Config/ApiUrl";
    import AppLibrary from "../../../Helpers/AppLibrary";
    import {urlGenerator} from "../../../Helpers/AxiosHelper";

    export default {
        name: "DomainSettings",
        components: {draggable},
        extends: AppLibrary,
        mixins: [FormMixin, UserMixin, GlobalHelperMixin],
        data() {
            return {
                domainNames: [],
                containerdetails: [],
                isActive: false,
                preloader: false,
                cdnList: [
                    {
                        id: 1,
                        value: 'Yes'
                    },
                    {
                        id: 0,
                        value: 'No'
                    }
                ],
            }
        },
        mounted() {
            const url = window.location.href;
            const lastParam = url.split("/").slice(-1)[0];
            const containerId = lastParam.split("?").slice(0)[0];

            this.fetchDetails(containerId);
            this.fetchDomains(containerId);
            setTimeout(() => {
                $('[data-toggle="tooltip"]').tooltip();
            }, 5000);
        },
        watch: {
            componentLoader: function (value) {
                if (value == false) {
                    setTimeout(() => {
                        let position = parseInt(localStorage.getItem('profileScrollPosition'));
                        if (position) {
                            window.scroll({
                                top: position,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }
                        localStorage.removeItem('profileScrollPosition');
                    });
                }
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 300
                };
            }
        },
        methods: {
            beforeSubmit() {
                this.scrollToTop(true);
                this.preloader = true;
            },
            fetchDetails(containerId) {
                fetch(urlGenerator(actions.CONTAINERTABLE_DETAILS+'/'+containerId)) // Hier müsste die URL der Ajax-Quelle eingefügt werden
                    .then(response => response.json())
                    .then(data => {
                    this.containerdetails = data;
                    })
                    .catch(error => {
                    console.error('Fehler beim Abrufen der Containerdetails:', error);
                    });
                
            },
            fetchDomains(containerId) {
                fetch(urlGenerator(actions.CONTAINERTABLE_DOMAINS+'/'+containerId)) // Hier müsste die URL der Ajax-Quelle eingefügt werden
                    .then(response => response.json())
                    .then(data => {
                    this.domainNames = data;
                    this.domainNames.push({ status: 'New', container_id: containerId});
                    this.isActive = true;
                    })
                    .catch(error => {
                    console.error('Fehler beim Abrufen der Containerdetails:', error);
                    });
                
            },
            editToggle(index) {
                $('[data-toggle="tooltip"]').tooltip("hide");
                this.isActive = false;
                this.domainNames[index].edit = !this.domainNames[index].edit;
                this.isActive = true;
                setTimeout(() => {
                    $('#domain-name-' + index).focus();
                });
            },
            removeDomainName(index) {
                $('[data-toggle="tooltip"]').tooltip("hide");
                this.isActive = false;
                this.domainNames[index].domain = null;
                this.isActive = true;
                this.update(this.domainNames[index]);
                this.domainNames.splice(this.domainNames.indexOf(index), 1);
            },
            addDomainName(index) {
                this.isActive = false;
                this.domainNames[index].edit = false;
                this.isActive = true;
                this.update(this.domainNames[index]);
            },
            update(data) {
                localStorage.setItem('domainsScrollPosition', window.scrollY + '');
                const url = actions.CONTAINERTABLE_DOMAINS_CHANGE;
                this.axiosPost({
                    url,
                    data
                }).then(res => {
                    this.$toastr.s(res.data.message);
                    location.reload();
                }).catch(err => {
                    this.$toastr.s(err.data.message);
                })
            },
            submit() {
                let submitData = this.containerdetails;
                this.save(submitData);
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
                window.location = urlGenerator(actions.MY_PROFILE);
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            dragstart(ev) {
                this.drag = true;
                ev.target.classList.add('catch-container');
                ev.item.classList.add('catch-item');
            },
            dragend(ev) {
                this.drag = false;
                ev.target.classList.remove('catch-container');
                ev.item.classList.remove('catch-item');
            },
            change(ev) {
            },
        }
    }
</script>
